import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';

export default function accessFormValidation() {
    const accessForm = document.querySelector('#accessBox form');

    if (accessForm) {
        // floating label when not empty
        const marketingConsent = accessForm.querySelectorAll('[name="marketing_consent"]');
        const formBtns = accessForm.querySelectorAll('[data-btn]');

        [].forEach.call(marketingConsent, (radio) => {
            radio.addEventListener('click', function () {
                const currentBtn = this.getAttribute('id');

                [].forEach.call(formBtns, (btn) => {
                    btn.classList.remove('visible');
                });

                accessForm.querySelector(`[data-btn='${currentBtn}']`).classList.add('visible');
            });
        });

        // floating label when not empty
        const formControl = accessForm.querySelectorAll('.form-control');

        [].forEach.call(formControl, (input) => {
            if (input.value !== '') {
                input.classList.add('not-empty');
                input.classList.remove('empty');
            }
            input.addEventListener('blur', function () {
                const tmpval = this.value;
                if (tmpval === '') {
                    this.classList.add('empty');
                    this.classList.remove('not-empty');
                } else {
                    this.classList.add('not-empty');
                    this.classList.remove('empty');
                }
            });
        });

        // validateForm
        const plugins = {
            trigger: new Trigger(),
            bootstrap3: new Bootstrap3(),
            submitButton: new SubmitButton(),
            declarative: new Declarative({
                html5Input: true,
            }),
        };
        if (document.getElementById('paywall_captcha_container')) {
            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onReCaptchaLoadPartnersAgency&render=explicit';
            script.async = true;
            document.body.append(script);
        }

        let recaptchaID;

        const submitForm = (recaptchaToken) => {
            accessForm.querySelector('[name=g-recaptcha-response]').value = recaptchaToken;
            accessForm.submit();
        };

        window.onReCaptchaLoadPartnersAgency = () => {
            recaptchaID = window.grecaptcha.render('paywall_captcha_container', {
                size: 'invisible',
                sitekey: process.env.INVISIBLE_RECAPTCHA_SITE_KEY,
                callback: (token) => {
                    submitForm(token);
                },
            });
        };

        const generateReCaptchaTokenAndSubmit = () => {
            window.grecaptcha.execute(recaptchaID);
        };

        const fv = formValidation(accessForm, {
            plugins,
        }).on('core.form.valid', () => {
            if (document.getElementById('paywall_captcha_container')) {
                generateReCaptchaTokenAndSubmit();
            } else {
                accessForm.submit();
            }
        });

        [].forEach.call(accessForm.querySelectorAll('input'), (input) => {
            input.addEventListener('focus', (e) => {
                fv.resetField(e.target.name);
            });
        });
    }
}
